/** Mirrors `@vello/business` `PARTNER_ACCOUNT_SUSPEND_REASONS` & co (the server validates; these drive the pickers). */
export const PARTNER_ACCOUNT_SUSPEND_REASONS = ['PARTNER_REQUEST', 'CREDIT_REVIEW', 'CONTRACT_ENDED', 'COMPLIANCE_REVIEW', 'FRAUD_SUSPECTED'];
export const PARTNER_ACCOUNT_REACTIVATE_REASONS = ['REVIEW_CLEARED', 'PARTNER_REQUEST', 'CONTRACT_RENEWED'];
export const PARTNER_LIMIT_REASONS = ['INITIAL_LIMIT', 'CREDIT_INCREASE', 'CREDIT_DECREASE', 'CREDIT_REVIEW', 'PARTNER_REQUEST'];
export const PARTNER_LIMIT_REJECT_REASONS = ['CREDIT_NOT_JUSTIFIED', 'AMOUNT_INCORRECT', 'NEEDS_DOCUMENTATION', 'DUPLICATE_REQUEST'];
export const PARTNER_MEMBER_SUSPEND_REASONS = ['LEAVE_OF_ABSENCE', 'PARTNER_REQUEST', 'SECURITY_REVIEW'];
export const PARTNER_MEMBER_REVOKE_REASONS = ['LEFT_THE_PARTNER', 'PARTNER_REQUEST', 'SECURITY_INCIDENT'];
export const PARTNER_MEMBER_REINSTATE_REASONS = ['RETURNED', 'REVIEW_CLEARED'];
export const PARTNER_ACCOUNT_EDIT_REASONS = ['DATA_CORRECTION', 'MARKET_EXPANSION', 'MARKET_EXIT', 'PARTNER_REQUEST'];
export const PARTNER_MEMBER_ROLES = ['owner', 'manager', 'agent'];
export class PartnerAccountAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    aid(accountId) {
        return encodeURIComponent(accountId);
    }
    register(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/partner-accounts', body: input, auth: true });
    }
    detail(accountId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/partner-accounts/${this.aid(accountId)}`, auth: true });
    }
    edit(accountId, input) {
        return this.client.request({ method: 'PATCH', path: `/v1/admin/partner-accounts/${this.aid(accountId)}`, body: input, auth: true });
    }
    setStatus(accountId, status, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-accounts/${this.aid(accountId)}/status`, body: { status, reasonCode }, auth: true });
    }
    /** Propose a new line (the maker). */
    proposeLimit(accountId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-accounts/${this.aid(accountId)}/limit-changes`, body: input, auth: true });
    }
    /** Approve a line another operator proposed (the checker; the maker is refused `SELF_APPROVAL`). */
    approveLimit(changeId) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-limit-changes/${encodeURIComponent(changeId)}/approve`, body: {}, auth: true });
    }
    rejectLimit(changeId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-limit-changes/${encodeURIComponent(changeId)}/reject`, body: { reasonCode }, auth: true });
    }
    /** Invite an existing operator sign-in (BUSINESS or MERCHANT) as a desk member; writes its PARTNER grant. */
    inviteMember(accountId, identifier, role) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-accounts/${this.aid(accountId)}/members`, body: { identifier, role }, auth: true });
    }
    /** A member's lifecycle: suspend ⇄ reinstate; revoke is terminal and removes the PARTNER grant. */
    memberAction(membershipId, action, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/partner-members/${encodeURIComponent(membershipId)}/${action}`, body: { reasonCode }, auth: true });
    }
}
//# sourceMappingURL=partner-accounts.js.map